module.exports = __webpack_public_path__ + "static/media/VK.66b30c3c.PNG";